import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Package, CalendarDays } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OrdersPage() {
  const { token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/orders`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { setOrders(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-2 border-[var(--violet)] border-t-transparent rounded-full"></div></div>;

  return (
    <div className="min-h-screen bg-[var(--cream)]" data-testid="orders-page">
      <div className="bg-white border-b border-[var(--sage)]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl font-bold text-[var(--dark)]">Mis Pedidos</h1>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {orders.length > 0 ? (
          <div className="space-y-4">
            {orders.map(order => (
              <div key={order.id} className="bg-white rounded-2xl p-6 border border-[var(--sage)]/20" data-testid={`order-${order.id}`}>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <Package className="h-5 w-5 text-[var(--violet)]" />
                    <span className="text-sm text-[var(--dark)]/50">#{order.id.slice(0, 8)}</span>
                  </div>
                  <Badge className={order.status === 'paid' ? 'bg-[var(--sage-light)] text-[var(--sage-dark)] border-0' : 'bg-yellow-50 text-yellow-700 border-0'}>
                    {order.status === 'paid' ? 'Pagado' : 'Pendiente'}
                  </Badge>
                </div>
                <div className="space-y-2">
                  {order.items?.map((item, i) => (
                    <div key={i} className="flex items-center justify-between text-sm">
                      <span className="text-[var(--dark)]/70">{item.name} x{item.quantity}</span>
                      <span className="font-medium">${(item.price * item.quantity).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-[var(--sage)]/10">
                  <div className="flex items-center gap-1.5 text-xs text-[var(--dark)]/30">
                    <CalendarDays className="h-3 w-3" /> {new Date(order.created_at).toLocaleDateString('es-ES')}
                  </div>
                  <span className="text-lg font-bold text-[var(--dark)]">${order.total?.toFixed(2)}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <Package className="h-12 w-12 text-[var(--dark)]/20 mx-auto mb-4" />
            <p className="text-lg text-[var(--dark)]/40">No tienes pedidos aun</p>
          </div>
        )}
      </div>
    </div>
  );
}
